export default __webpack_public_path__ + "static/media/Rubik-MediumItalic.e5a23a26.woff2";